import { FC } from "react";

import { ComplaintStatusCell } from "../../grid";
import { IRenderColumnTemplate } from "./_core";

export const ComplaintStatusCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
}) => {
  return <ComplaintStatusCell status={value}></ComplaintStatusCell>;
};
